import React from 'react'
import FeaturedCourses from '../components/FeaturedCourses'
import Carousel from 'nuka-carousel'

const Featured = (props) => {
  const TheData = props.jsonData;
  const Featured = TheData.filter(course => course.featured == "Featured")

  return (
    <Carousel className="featureArea"
      autoplay={false}
      swiping={true}>
        {Featured.map((feature, idx) => {
          return <FeaturedCourses
            key={idx}
            title={feature.en_us_lesson_name}
            desc={feature.feature_text}
            screenshot={feature.screenshot}
            img={feature.feature_img}
            header={feature.feature_header}
            localURL={props.localURL}
            url={feature.url_title}
            homeOverlay={props.themeStyles.homeOverlay}
          />
        })}
    </Carousel>
  )

}

export default Featured
